import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Add-client drawer. Emits `{ name: 'resp', value: client }` on save and `{ name: 'isVisible', value: false }` on close. */
@Component({
  selector: 'app-add-edit-client-popup',
  templateUrl: './add-edit-client-popup.component.html',
})
export class AddEditClientPopupComponent {
  @Input() basicShow = false;
  /** Used when the topbar company is "All" so the caller's company is preselected. */
  @Input() defaultCompanyId: string | null = null;
  @Input() initialName = '';
  @Output() addClientPopupOnChange = new EventEmitter<{ name: string; value: any }>();

  onSaved(client: any): void {
    this.addClientPopupOnChange.emit({ name: 'resp', value: client });
  }

  close(): void {
    this.basicShow = false;
    this.addClientPopupOnChange.emit({ name: 'isVisible', value: false });
  }
}
